/* DBA Couture — Livre sur-mesure : feuilletage (double page ≥ 900 px, page simple en dessous) */
(function () {
  'use strict';
  var SPREAD_MQ = '(min-width: 900px)';

  function DblBook(root) {
    this.root = root;
    this.pagesWrap = root.querySelector('[data-dbl-pages]');
    this.book = root.querySelector('[data-dbl-book]');
    this.pages = Array.prototype.slice.call(this.pagesWrap.querySelectorAll('.dbl-page'));
    if (!this.pages.length) return;
    this.prevBtn = root.querySelector('[data-dbl-prev]');
    this.nextBtn = root.querySelector('[data-dbl-next]');
    this.countEl = root.querySelector('[data-dbl-count]');
    this.chapEl = root.querySelector('[data-dbl-chapters]');
    this.mq = window.matchMedia(SPREAD_MQ);
    this.k = 0;          // nombre de feuillets tournés
    this.page = 0;       // première page visible
    this.leaves = [];
    this.queue = null;
    root.classList.add('is-book');
    this.buildChapters();
    this.build();
    this.bind();
  }

  DblBook.prototype.build = function () {
    var self = this;
    this.spread = this.mq.matches;
    this.root.classList.toggle('is-spread', this.spread);
    // remettre les pages à leur place, supprimer les anciens feuillets
    this.pages.forEach(function (p) { self.pagesWrap.appendChild(p); });
    this.leaves.forEach(function (l) { l.remove(); });
    this.leaves = [];
    var n = this.spread ? Math.ceil(this.pages.length / 2) : this.pages.length;
    for (var i = 0; i < n; i++) {
      var leaf = document.createElement('div');
      leaf.className = 'dbl-leaf';
      var front = document.createElement('div');
      front.className = 'dbl-face dbl-face--front';
      var back = document.createElement('div');
      back.className = 'dbl-face dbl-face--back';
      var fp = this.spread ? this.pages[2 * i] : this.pages[i];
      var bp = this.spread ? this.pages[2 * i + 1] : null;
      front.appendChild(fp);
      if (bp) back.appendChild(bp); else back.classList.add('dbl-face--blank');
      leaf.appendChild(front); leaf.appendChild(back);
      leaf.addEventListener('transitionend', this.onTurnEnd.bind(this, leaf));
      this.book.appendChild(leaf);
      this.leaves.push(leaf);
    }
    this.maxK = this.spread ? (this.pages.length % 2 === 0 ? n : n - 1) : n - 1;
    this.k = Math.max(0, Math.min(this.maxK, this.kForPage(this.page)));
    this.book.classList.add('no-anim');
    this.render(true);
    void this.book.offsetWidth;
    this.book.classList.remove('no-anim');
  };

  DblBook.prototype.kForPage = function (p) {
    if (!this.spread) return p;
    return p % 2 === 0 ? p / 2 : (p + 1) / 2;
  };

  DblBook.prototype.visiblePages = function () {
    if (!this.spread) return [this.k];
    var out = [];
    if (this.k > 0) out.push(2 * this.k - 1);
    if (2 * this.k < this.pages.length) out.push(2 * this.k);
    return out;
  };

  DblBook.prototype.render = function (instant) {
    var self = this, n = this.leaves.length;
    this.leaves.forEach(function (leaf, i) {
      var flipped = i < self.k;
      if (!instant && flipped !== leaf.classList.contains('is-flipped')) leaf.classList.add('is-turning');
      leaf.classList.toggle('is-flipped', flipped);
      leaf.style.zIndex = leaf.classList.contains('is-turning') ? n + 5 : (flipped ? i + 1 : n - i);
      leaf.classList.toggle('is-top', i === self.k || (self.spread && i === self.k - 1));
      if (!self.spread) {
        if (!flipped) leaf.classList.remove('is-gone');
        else if (instant) leaf.classList.add('is-gone');
      }
    });
    this.book.classList.toggle('is-start', this.spread && this.k === 0);
    this.book.classList.toggle('is-end', this.spread && this.k === n && this.pages.length % 2 === 0);

    var vis = this.visiblePages();
    this.page = vis[0];
    this.pages.forEach(function (p, i) {
      var shown = vis.indexOf(i) !== -1;
      p.setAttribute('aria-hidden', shown ? 'false' : 'true');
      if ('inert' in p) p.inert = !shown;
      p.classList.toggle('is-near', Math.abs(i - self.page) <= 3);
    });
    if (this.prevBtn) this.prevBtn.disabled = this.k <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.k >= this.maxK;
    if (this.countEl) {
      var a = vis[0] + 1, b = vis[vis.length - 1] + 1;
      this.countEl.textContent = (a === b ? 'Page ' + a : 'Pages ' + a + '–' + b) + ' / ' + this.pages.length;
    }
    if (this.chapBtns) this.chapBtns.forEach(function (btn, i) { btn.setAttribute('aria-current', vis.indexOf(i) !== -1 ? 'true' : 'false'); });
  };

  DblBook.prototype.onTurnEnd = function (leaf, e) {
    if (e.target !== leaf || e.propertyName !== 'transform') return;
    leaf.classList.remove('is-turning');
    var i = this.leaves.indexOf(leaf), n = this.leaves.length, flipped = leaf.classList.contains('is-flipped');
    leaf.style.zIndex = flipped ? i + 1 : n - i;
    if (!this.spread && flipped) leaf.classList.add('is-gone');
  };

  DblBook.prototype.step = function (dir) {
    var k = this.k + dir;
    if (k < 0 || k > this.maxK) return false;
    if (!this.spread && dir < 0) this.leaves[k].classList.remove('is-gone');
    this.k = k;
    this.render(false);
    return true;
  };

  DblBook.prototype.goToK = function (target) {
    var self = this;
    target = Math.max(0, Math.min(this.maxK, target));
    clearTimeout(this.queue);
    (function tick() {
      if (self.k === target) return;
      self.step(target > self.k ? 1 : -1);
      if (self.k !== target) self.queue = setTimeout(tick, 170);
    })();
  };

  DblBook.prototype.goToPage = function (p) { this.goToK(this.kForPage(p)); };
  DblBook.prototype.next = function () { clearTimeout(this.queue); this.step(1); };
  DblBook.prototype.prev = function () { clearTimeout(this.queue); this.step(-1); };

  DblBook.prototype.buildChapters = function () {
    var self = this;
    if (!this.chapEl) return;
    this.chapEl.innerHTML = '';
    this.chapBtns = this.pages.map(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = p.getAttribute('data-titre') || ('Page ' + (i + 1));
      b.addEventListener('click', function () { self.goToPage(i); });
      self.chapEl.appendChild(b);
      return b;
    });
  };

  DblBook.prototype.inView = function () {
    var r = this.root.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  };

  DblBook.prototype.bind = function () {
    var self = this;
    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.prev(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.next(); });

    // clic sur le livre : moitié gauche = retour, moitié droite = suivant
    this.book.addEventListener('click', function (e) {
      if (self.swiped) { self.swiped = false; return; }
      if (e.target.closest('a, button, input, select, textarea')) return;
      var r = self.book.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      if (self.spread) {
        x < 0.5 ? self.prev() : self.next();
      } else {
        x < 0.33 ? self.prev() : self.next();
      }
    });

    // swipe
    var sx = 0, sy = 0, tracking = false;
    this.book.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    this.book.addEventListener('touchend', function (e) {
      if (!tracking) return; tracking = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        self.swiped = true;
        setTimeout(function () { self.swiped = false; }, 400);
        dx < 0 ? self.next() : self.prev();
      }
    }, { passive: true });

    // clavier
    this.onKey = function (e) {
      if (!self.inView() || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { self.next(); e.preventDefault(); }
      else if (e.key === 'ArrowLeft' || e.key === 'PageUp') { self.prev(); e.preventDefault(); }
      else if (e.key === 'Home') { self.goToK(0); }
      else if (e.key === 'End') { self.goToK(self.maxK); }
    };
    document.addEventListener('keydown', this.onKey);

    // passage mobile <-> bureau
    this.onMq = function () { self.build(); };
    if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
    else this.mq.addListener(this.onMq);
  };

  DblBook.prototype.destroy = function () {
    document.removeEventListener('keydown', this.onKey);
    if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
    else this.mq.removeListener(this.onMq);
  };

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-dbl]').forEach(function (el) {
      if (el.__dbl) return;
      el.__dbl = new DblBook(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Éditeur de thème Shopify
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-dbl]');
    if (el && el.__dbl && el.__dbl.destroy) el.__dbl.destroy();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest('[data-dbl]');
    if (!el || !el.__dbl || !el.__dbl.pages) return;
    var i = el.__dbl.pages.indexOf(e.target);
    if (i !== -1) el.__dbl.goToPage(i);
  });
})();
